(function(){
var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var secs=$$('.tally-page'),N=secs.length,step=0,S={};
try{S=JSON.parse(localStorage.getItem('quiz')||'{}')}catch(e){}
var LANGS=['English','Spanish','French','German','Portuguese','Italian','Dutch','Polish','Russian','Japanese','Korean','Chinese','Arabic','Hindi','Turkish','Swedish'];
var KEYS=[['recipient','name'],['genre','voice'],['qualities'],['moments'],['message'],['language','email','phone']];
function save(){localStorage.setItem('quiz',JSON.stringify(S))}
function groups(sec){var g={};$$('input[type=radio]',sec).forEach(function(r){(g[r.name]=g[r.name]||[]).push(r)});return Object.keys(g).map(function(k){return g[k]})}
/* stored value = data-value (stable, used by preview/checkout); falls back to the visible label */
function label(r){return r.getAttribute('data-value')||$('label[for="'+r.id+'"]',r.closest('.tally-page')).textContent.trim()}
function syncSel(sec){$$('.tally-multiple-choice-option',sec).forEach(function(o){var r=$('input',o);o.classList.toggle('tally-multiple-choice-option-selected',!!(r&&r.checked))})}
function collect(i){
  var sec=secs[i],k=KEYS[i];
  if(i===0){var c=$('input[type=radio]:checked',sec);if(c)S.recipient=label(c);S.name=$('input[type=text]',sec).value.trim()}
  if(i===1){var gs=groups(sec);[['genre',0],['voice',1]].forEach(function(p){var c=gs[p[1]].filter(function(r){return r.checked})[0];if(c)S[p[0]]=label(c)})}
  if(i>=2&&i<=4){S[k[0]]=$('textarea',sec).value.trim()}
  if(i===5){S.language=$('.tally-block-dropdown input',sec).value;S.email=$('input[type=email]',sec).value.trim();S.phone=$('input[type=tel]',sec).value.trim()}
  save();
}
function restore(){
  secs.forEach(function(sec,i){
    if(i===0){if(S.recipient)$$('input[type=radio]',sec).forEach(function(r){r.checked=label(r)===S.recipient});$('input[type=text]',sec).value=S.name||''}
    if(i===1){var gs=groups(sec);[['genre',0],['voice',1]].forEach(function(p){gs[p[1]].forEach(function(r){r.checked=label(r)===S[p[0]]})})}
    if(i>=2&&i<=4&&S[KEYS[i][0]])$('textarea',sec).value=S[KEYS[i][0]];
    if(i===5){$('.tally-block-dropdown input',sec).value=S.language||'English';$('input[type=email]',sec).value=S.email||'';$('input[type=tel]',sec).value=S.phone||''}
    syncSel(sec);
  });
}
function show(n,dir){
  step=n;secs.forEach(function(s,i){s.classList.toggle('is-active',i===n);s.classList.remove('rh-slide-right','rh-slide-left')});
  secs[n].classList.add(dir<0?'rh-slide-left':'rh-slide-right');
  var m=$('.mention',secs[5]);if(m)m.textContent=S.name||'them';
  scrollTo(0,0);
}
function err(sec,el,msg){
  $$('.tally-validation-error',sec).forEach(function(e){e.remove()});
  var d=document.createElement('div');d.className='tally-validation-error';d.setAttribute('role','alert');d.textContent=msg;
  el.parentNode.insertBefore(d,el.nextSibling);
}
function validate(i){
  var sec=secs[i];$$('.tally-validation-error',sec).forEach(function(e){e.remove()});
  var ok=true;
  groups(sec).forEach(function(g){if(ok&&!g.some(function(r){return r.checked})){var fs=g[0].closest('fieldset')||g[0].closest('.tally-block');err(sec,fs,'Please choose one of the options above.');ok=false}});
  if(!ok)return false;
  if(i===0){var n=$('input[type=text]',sec);if(!n.value.trim()){err(sec,n.closest('.tally-block'),'Please tell us their name.');n.focus();return false}}
  if(i===5){
    var e=$('input[type=email]',sec),p=$('input[type=tel]',sec);
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e.value.trim())){err(sec,e.closest('.tally-block'),'Please enter a valid email address so we can send your song.');e.focus();return false}
    if(!/^\+?[\d\s().-]{7,}$/.test(p.value.trim())||p.value.replace(/\D/g,'').length<7){err(sec,p.closest('.tally-block'),'Please enter a phone number with at least 7 digits.');p.focus();return false}
  }
  return true;
}
/* start the real song via the song API (window.CIRA_SONG_API, set in the layout; empty = off).
   never holds navigation more than 4 s: if slower, the preview page asks again with the same quizId (the server dedupes) */
function startSong(){
  var api=(window.CIRA_SONG_API||'').replace(/\/+$/,'');
  if(!api||!window.fetch)return Promise.resolve();
  var a={};['name','recipient','occasion','genre','voice','language','qualities','moments','message'].forEach(function(k){if(S[k])a[k]=S[k]});
  /* text/plain keeps it a CORS "simple" request (no preflight round trip); the body is still JSON */
  var req=fetch(api+'/api/song',{method:'POST',headers:{'Content-Type':'text/plain;charset=UTF-8'},body:JSON.stringify({quizId:S.quizId,answers:a}),keepalive:true})
    .then(function(r){return r.json()}).then(function(j){if(j&&j.taskId){S.songTaskId=j.taskId;save()}}).catch(function(){});
  return Promise.race([req,new Promise(function(r){setTimeout(r,4000)})]);
}
secs.forEach(function(sec,i){
  var form=$('form',sec);form.noValidate=true;
  $$('input[type=radio]',sec).forEach(function(r){r.addEventListener('change',function(){syncSel(sec);$$('.tally-validation-error',sec).forEach(function(e){e.remove()})})});
  $$('.tally-multiple-choice-option',sec).forEach(function(o){o.addEventListener('click',function(e){var r=$('input',o);if(r&&e.target!==r&&e.target.tagName!=='LABEL'){r.checked=true;r.dispatchEvent(new Event('change',{bubbles:true}))}})});
  form.addEventListener('submit',function(e){
    e.preventDefault();if(!validate(i))return;collect(i);
    if(i<N-1)show(i+1,1);
    else{S.quizId='q-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,8);S.submittedAt=new Date().toISOString();delete S.songTaskId;delete S.songTrackId;delete S.songAudioUrl;save();
      location.href='/pages/custom-song-preview'}  /* song is generated on the preview page after ~60 s of VSL watched */
  });
  var bk=$('.tally-back-button button',sec);
  if(bk)bk.addEventListener('click',function(e){e.preventDefault();collect(i);show(i-1,-1)});
});
/* language dropdown */
var dd=$('.tally-block-dropdown'),inp=$('input',dd),list;
inp.readOnly=true;
function closeList(){if(list){list.remove();list=null;inp.setAttribute('aria-expanded','false')}}
inp.addEventListener('click',function(e){
  e.stopPropagation();if(list){closeList();return}
  list=document.createElement('ul');list.className='rh-list';list.setAttribute('role','listbox');
  LANGS.forEach(function(l){var li=document.createElement('li');li.textContent=l;li.setAttribute('role','option');if(l===inp.value)li.className='sel';li.addEventListener('click',function(ev){ev.stopPropagation();inp.value=l;closeList()});list.appendChild(li)});
  inp.parentNode.parentNode.appendChild(list);inp.setAttribute('aria-expanded','true');
});
document.addEventListener('click',closeList);
restore();
var q=new URLSearchParams(location.search).get('step');
show(Math.min(Math.max((+q||1)-1,0),N-1),1);
})();
